export interface FaqPageItem {
  slug: string;
  question: string;
  answer: string;
}

export const FAQ_PAGE_ITEMS: FaqPageItem[] = [
  {
    slug: "que-es-la-nom-035",
    question: "¿Qué es la NOM-035-STPS?",
    answer:
      "La NOM-035-STPS-2018 es la norma oficial mexicana, emitida por la Secretaría del Trabajo y Previsión Social (STPS), que establece los elementos para identificar, analizar y prevenir los factores de riesgo psicosocial en los centros de trabajo, así como para promover un entorno organizacional favorable.",
  },
  {
    slug: "a-quien-aplica",
    question: "¿A qué empresas aplica la NOM-035 y qué obligaciones tiene cada una?",
    answer:
      "Aplica a todos los centros de trabajo en México. Las obligaciones crecen según el número de trabajadores: los centros de hasta 15 trabajadores deben identificar y prevenir los factores de riesgo psicosocial; de 16 a 50, además deben evaluar el entorno organizacional; y los de más de 50 trabajadores tienen el nivel más amplio de evaluación y medidas de control.",
  },
  {
    slug: "factores-de-riesgo-psicosocial",
    question: "¿Cuáles son los factores de riesgo psicosocial que identifica la norma?",
    answer:
      "Incluyen las condiciones del ambiente de trabajo, cargas de trabajo excesivas, falta de control sobre las tareas, jornadas de trabajo prolongadas, interferencia entre el trabajo y la vida familiar, liderazgo negativo, relaciones negativas en el trabajo y violencia laboral.",
  },
  {
    slug: "entorno-organizacional-favorable",
    question: "¿Qué es el entorno organizacional favorable?",
    answer:
      "Es el conjunto de condiciones que promueven el desarrollo integral de los trabajadores: sentido de pertenencia, capacitación, definición precisa de responsabilidades, participación proactiva y una distribución adecuada de cargas de trabajo. La NOM-035 obliga a promoverlo activamente, no solo a evitar riesgos.",
  },
  {
    slug: "guias-de-referencia",
    question: "¿Qué son las Guías de Referencia I, II y III?",
    answer:
      "Son los instrumentos oficiales de la STPS para aplicar la NOM-035. La Guía I identifica y clasifica a los trabajadores expuestos a acontecimientos traumáticos severos; la Guía II identifica a los trabajadores expuestos a factores de riesgo psicosocial; la Guía III evalúa el entorno organizacional. Cuál aplica depende del tamaño del centro de trabajo.",
  },
  {
    slug: "frecuencia-evaluacion",
    question: "¿Con qué frecuencia debe aplicarse la evaluación de la NOM-035?",
    answer:
      "La evaluación debe repetirse de forma periódica, generalmente cada año o cuando ocurran cambios significativos en las condiciones de trabajo, para mantener actualizado el diagnóstico y el plan de acción de la empresa.",
  },
  {
    slug: "acontecimiento-traumatico-severo",
    question: "¿Qué es un acontecimiento traumático severo?",
    answer:
      "Es un evento vivido durante o con motivo del trabajo —como un accidente grave, un acto de violencia o un desastre— que puede generar en el trabajador un trastorno de estrés postraumático. La NOM-035 obliga a identificar a los trabajadores expuestos y canalizarlos a atención especializada.",
  },
  {
    slug: "violencia-laboral",
    question: "¿Qué considera la NOM-035 como violencia laboral?",
    answer:
      "Incluye el acoso, el hostigamiento, los actos de discriminación y otras formas de malos tratos ejercidos dentro del centro de trabajo. Identificarla y prevenirla es parte central de la evaluación de factores de riesgo psicosocial.",
  },
  {
    slug: "como-se-documenta-cumplimiento",
    question: "¿Cómo se documenta el cumplimiento de la NOM-035?",
    answer:
      "A través de un expediente que integra la política de prevención de riesgos psicosociales, los resultados de las evaluaciones aplicadas, las medidas de control adoptadas y los registros de las acciones de seguimiento. MAPA35 organiza todo este expediente de forma trazable, por trabajador y por centro de trabajo.",
  },
  {
    slug: "que-pasa-si-no-cumplo",
    question: "¿Qué pasa si mi empresa no cumple con la NOM-035?",
    answer:
      "La STPS puede observar y sancionar el incumplimiento durante una inspección conforme a la Ley Federal del Trabajo, y la falta de evidencia documental deja a la empresa expuesta ante demandas laborales relacionadas con el entorno de trabajo. MAPA35 genera esa evidencia de forma trazable para que puedas demostrar cumplimiento en cualquier momento.",
  },
  {
    slug: "responsable-dentro-de-la-empresa",
    question: "¿Quién dentro de la empresa es responsable de cumplir la NOM-035?",
    answer:
      "La responsabilidad recae en la organización, normalmente encabezada por la dirección junto con el área de Recursos Humanos. En centros de trabajo más grandes suele involucrarse también el área de seguridad e higiene o una comisión interna dedicada al seguimiento.",
  },
  {
    slug: "diferencia-nom-030",
    question: "¿La NOM-035 es lo mismo que la NOM-030?",
    answer:
      "No. La NOM-030-STPS regula los servicios de seguridad y salud en el trabajo en general —cómo se organiza esa función dentro de la empresa—, mientras que la NOM-035 se enfoca específicamente en identificar, analizar y prevenir los factores de riesgo psicosocial.",
  },
  {
    slug: "como-ayuda-mapa35",
    question: "¿Cómo ayuda MAPA35 a cumplir con la NOM-035?",
    answer:
      "MAPA35 acompaña a tu empresa en 6 etapas: diagnóstico inicial, evaluación estructurada con los instrumentos oficiales de la STPS, integración del expediente documental, diseño del plan de acción, implementación guiada y seguimiento anual, todo con evidencia trazable por trabajador y centro de trabajo.",
  },
  {
    slug: "diagnostico-tiene-costo",
    question: "¿El diagnóstico inicial con MAPA35 tiene costo?",
    answer:
      "No. El diagnóstico inicial de MAPA35 es gratuito y sirve para evaluar el estado de cumplimiento actual de tu empresa antes de definir cualquier plan de acción.",
  },
  {
    slug: "informacion-recabada-y-confidencialidad",
    question: "¿Qué información se recaba en las evaluaciones y cómo se protege?",
    answer:
      "Las evaluaciones recaban respuestas de los trabajadores sobre su percepción del entorno laboral y posibles factores de riesgo psicosocial. Esta información es sensible y debe manejarse de forma confidencial, con acceso restringido y resultados reportados de forma agregada, no individual, salvo en los casos que la propia norma prevé para dar seguimiento a un trabajador expuesto.",
  },
  {
    slug: "examen-medico-obligatorio",
    question: "¿Es obligatorio el examen médico o la valoración psicológica bajo la NOM-035?",
    answer:
      "La NOM-035 no exige un examen médico generalizado a toda la plantilla. Lo que sí obliga es canalizar a valoración o atención especializada a los trabajadores identificados como expuestos a un acontecimiento traumático severo o a factores de riesgo psicosocial significativos, según los resultados de las Guías de Referencia.",
  },
  {
    slug: "riesgo-psicosocial-vs-estres-laboral",
    question: "¿Qué diferencia hay entre riesgo psicosocial y estrés laboral?",
    answer:
      "El riesgo psicosocial es la condición de trabajo que puede causar daño —una carga excesiva, un liderazgo negativo—, mientras que el estrés laboral es una posible consecuencia de estar expuesto a esos riesgos. La NOM-035 se enfoca en identificar y controlar las condiciones (la causa), no solo en atender sus efectos.",
  },
  {
    slug: "que-es-hostigamiento",
    question: "¿Qué es el hostigamiento según la NOM-035?",
    answer:
      "El hostigamiento es una forma de violencia laboral que consiste en el ejercicio de poder en una relación de subordinación real, que se expresa en conductas verbales, físicas o ambas orientadas a intimidar, humillar o denigrar a un trabajador. La NOM-035 obliga a identificarlo y a establecer mecanismos para atenderlo.",
  },
  {
    slug: "obligaciones-del-trabajador",
    question: "¿Qué obligaciones tiene el trabajador, además del patrón?",
    answer:
      "Los trabajadores deben participar en la aplicación de los cuestionarios de evaluación, colaborar en la identificación de factores de riesgo y observar las medidas de prevención que la empresa establezca. El cumplimiento de la NOM-035 depende de la colaboración de ambas partes, no solo de las acciones del empleador.",
  },
  {
    slug: "nom-035-home-office",
    question: "¿La NOM-035 aplica al trabajo remoto o home office?",
    answer:
      "Aplica en la medida en que existan condiciones laborales evaluables, pero la norma no fue diseñada originalmente pensando en el teletrabajo, por lo que su aplicación en esquemas remotos suele adaptarse caso por caso. Este es un punto que conviene validar con un especialista según el esquema específico de cada empresa.",
  },
  {
    slug: "trabajador-se-niega-a-responder",
    question: "¿Qué pasa si un trabajador se niega a responder el cuestionario?",
    answer:
      "La aplicación de los cuestionarios debe ser voluntaria y confidencial; no se puede obligar a un trabajador a responder. Sin embargo, la empresa debe documentar el esfuerzo por aplicar la evaluación a toda la plantilla, ya que la evidencia de haberlo intentado también forma parte del expediente de cumplimiento.",
  },
  {
    slug: "capacitacion-obligatoria",
    question: "¿La NOM-035 exige capacitar a los trabajadores?",
    answer:
      "Sí. La empresa debe difundir y capacitar a los trabajadores sobre la política de prevención de riesgos psicosociales, los factores identificados y las medidas de control adoptadas, para que el entorno organizacional favorable no quede solo en un documento sino en prácticas conocidas por todos.",
  },
  {
    slug: "evidencia-en-inspeccion",
    question: "¿Qué evidencia suele solicitar la STPS durante una inspección?",
    answer:
      "Típicamente solicita la política de prevención de riesgos psicosociales, los resultados de las evaluaciones aplicadas, el registro de los trabajadores expuestos identificados, las medidas de control implementadas y el plan de acción con sus responsables y plazos. MAPA35 organiza todo esto en un expediente trazable, listo para presentarse.",
  },
  {
    slug: "relacion-comision-seguridad-e-higiene",
    question: "¿Qué relación tiene la NOM-035 con la Comisión de Seguridad e Higiene?",
    answer:
      "Son obligaciones distintas pero complementarias. La Comisión de Seguridad e Higiene es un órgano bipartito (empresa-trabajadores) que investiga accidentes y condiciones inseguras en general; la NOM-035 exige específicamente identificar y prevenir factores de riesgo psicosocial. En muchas empresas, la comisión participa en el seguimiento de las acciones derivadas de la NOM-035.",
  },
  {
    slug: "relacion-ley-federal-del-trabajo",
    question: "¿Cómo se relaciona la NOM-035 con la Ley Federal del Trabajo?",
    answer:
      "La NOM-035 es una norma técnica que desarrolla, en materia de riesgo psicosocial, las obligaciones generales de seguridad y salud en el trabajo que ya establece la Ley Federal del Trabajo. El incumplimiento de una NOM se sanciona conforme a los procedimientos y criterios que la propia Ley Federal del Trabajo define.",
  },
  {
    slug: "empresa-con-varios-centros-de-trabajo",
    question: "¿Qué pasa si mi empresa tiene varios centros de trabajo?",
    answer:
      "Las obligaciones de la NOM-035 se evalúan por centro de trabajo, no por el tamaño total de la empresa. Cada centro de trabajo debe tener su propia evaluación, su propio expediente y, si corresponde, su propio plan de acción, aunque pertenezcan a la misma razón social.",
  },
  {
    slug: "burnout-y-nom-035",
    question: "¿Qué es el síndrome de desgaste ocupacional (burnout) y lo cubre la NOM-035?",
    answer:
      "El síndrome de desgaste ocupacional, conocido como burnout, es un estado de agotamiento físico y emocional asociado a la exposición prolongada a factores de riesgo psicosocial en el trabajo. La NOM-035 no usa ese término de forma literal, pero los factores que obliga a prevenir —cargas excesivas, falta de control, liderazgo negativo— están directamente relacionados con sus causas.",
  },
  {
    slug: "actualizacion-politica-prevencion",
    question: "¿Con qué frecuencia se debe actualizar la política de prevención de riesgos psicosociales?",
    answer:
      "Debe revisarse y actualizarse cada vez que cambian las condiciones de trabajo de forma significativa, y como parte del ciclo periódico de evaluación de la empresa —generalmente anual—, para que siga reflejando los riesgos reales identificados y las medidas vigentes.",
  },
  {
    slug: "mapa35-para-empresas-pequenas",
    question: "¿MAPA35 sirve para empresas con un solo centro de trabajo pequeño?",
    answer:
      "Sí. La NOM-035 aplica desde el centro de trabajo con un solo empleado, y MAPA35 adapta el alcance de la evaluación y el expediente al nivel de obligaciones que corresponde según el número de trabajadores, sin pedirle a una empresa pequeña más de lo que la norma exige.",
  },
  {
    slug: "detecto-violencia-laboral-durante-evaluacion",
    question: "¿Qué pasa si detecto un caso de violencia laboral durante la evaluación?",
    answer:
      "La empresa debe darle seguimiento específico: documentar el caso, activar los mecanismos de atención que su política de prevención establezca y adoptar medidas correctivas. No es algo que se resuelva solo con el diagnóstico general — requiere una respuesta directa hacia el trabajador afectado.",
  },
];
